/**
 * Maps a Report's ids array into a human-readable string of Sectors
 * @param {number[]} ids
 * @returns
 */
const getSectorNames = (ids) => {
  const sectors = WP.sectorIdMap
    .filter((sector) => ids.includes(sector.id))
    .map((sector) => sector.title);

  return sectors.length ? sectors.join(", ") : "";
};

export default getSectorNames;
